export default __webpack_public_path__ + "static/media/authentication-icon.50eccfac.svg";